import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatQueueUpdatedEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from './'

export const queueUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        event_cause, // eslint-disable-line @typescript-eslint/no-unused-vars
        queue_request, // eslint-disable-line @typescript-eslint/no-unused-vars
        queue_id,
        ...properties
    } = extractProperties<NinchatQueueUpdatedEvent>(action.payload)

    const queues = queue_id in (state.user_queues ?? {}) ? 'user_queues' : '_queues'

    const existingQueue = state[queues]?.[queue_id]

    // queue_updated is a partial update for queue_settings: merge one level deep
    // to preserve optional fields the event omits (e.g. the undocumented
    // shared_canned_messages).
    //
    // queue_attrs, by contrast, represents full current state — the Ninchat API
    // omits an attribute entirely when it resets to its default (0/false/null).
    // Merging would incorrectly preserve old non-zero values, so replace it fully.
    return {
        ...state,
        [queues]: {
            ...state[queues],
            [queue_id]: {
                ...existingQueue,
                ...properties,
                queue_attrs: {...properties.queue_attrs},
                queue_settings: {
                    ...existingQueue?.queue_settings,
                    ...properties.queue_settings,
                },
            },
        },
        ...state._user_realm_queues && state._user_realm_queues[queue_id]
            ? {
                _user_realm_queues: {
                    ...state._user_realm_queues,
                    [queue_id]: {
                        ...state._user_realm_queues[queue_id],
                        ...properties,
                    },
                },
            }
            : {},
    }
}
